import Table from "../../componentsTable/TanStackTable";
import { petitions } from "../../../api/calls";
import { useContext, useEffect, useState, useRef } from "react";
import { toast } from "sonner";
import { DataContext } from "../../../context/DataContext";
import { useForm } from "react-hook-form";
import TableLoad from "../../componentsTools/TableLoad";
import { exportToExcel_v1 } from "../../componentsTools/ExportToExcel";

export default function Series() {
  const { session, idEmpresa } = useContext(DataContext);
  const [filtering, setFiltering] = useState("");
  const [estado, setEstado] = useState(false);
  const [series, setSeries] = useState([]);
  const [load, setLoad] = useState(true);
  const [comprobantes, setComprobantes] = useState([]);

  const modalRef = useRef(null);
  const modalRef2 = useRef(null);

  const form1 = useForm({
    defaultValues: {
      tipComprobante: "",
      serie: "",
      descripcion: "",
    },
  });

  const form2 = useForm({
    defaultValues: {
      "idSerie": "",
      tipComprobante: "",
      serie: "",
      descripcion: "",
      "estado":"",
      "defecto":""
    },
  });

  const columns = [
    {
      header: "Serie",
      accessorKey: "serie",
    },
    {
      header: "Tipo de Documento",
      accessorKey: "descripcionComprobante",
    },
    {
      header: "Descripción",
      accessorKey: "descripcion",
    },
    {
      header: "Defecto",
      accessorKey: "defecto",
      cell: ({ row }) => {
        const value = row.getValue("defecto");
        return (
          <span
            className={(value === "S") ? "text-success fw-bold" : "text-danger fw-bold"}
          >
            {(value === "S") ? "🟢" : "🔴"}
          </span>
        );
      },
    },
    {
      header: "Estado",
      accessorKey: "estado",
      cell: ({ row }) => {
        const value = row.getValue("estado");
        return (
          <span
            className={(value === "S") ? "text-success fw-bold" : "text-danger fw-bold"}
          >
            {(value === "S") ? "🟢" : "🚫"}
          </span>
        );
      },
    },
    {
      header: "Acciones",
      accessorKey: "acciones",
      cell: ({ row }) => (
        <div className="btn-reveal-trigger position-static">
          <button
            className="btn btn-sm dropdown-toggle dropdown-caret-none transition-none btn-reveal fs-10"
            type="button"
            data-bs-toggle="dropdown"
            data-boundary="window"
            aria-haspopup="true"
            aria-expanded="false"
            data-bs-reference="parent"
          >
            <span className="fas fa-ellipsis-h fs-10"></span>
          </button>
          <div className="dropdown-menu dropdown-menu-end py-2">
            <button
              className="dropdown-item"
              onClick={() => updateDefecto(row.original)}
            >
              <span className="text-body-secondary">{(row.original.defecto === "N") ? "Activar por defecto": "Quitar por defecto"}</span>
            </button>
            <button
              className="dropdown-item"
              onClick={() => updateEstado(row.original)}
            >
              <span className="text-body-secondary"> {(row.original.estado === "S") ? "Inhabilitar": "Habilitar"} </span>
            </button>
            <div className="dropdown-divider"></div>
            <button
              className="dropdown-item text-info"
                onClick={() => handleUpdate(row.original)}
            >
              Editar
            </button>
            <button
              className="dropdown-item text-danger"
              onClick={() => deleteSerie(row.original)}
            >
              Eliminar
            </button>
          </div>
        </div>
      ),
    },
  ];

  useEffect(() => {
    const fetchSeries = async () => {
      setLoad(true);
      const obj = session();
      const response = await petitions.getSeries(idEmpresa(), obj.token);
      if (response.status === "success") {
        setSeries(response.data);
        setLoad(false);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchSeries();
  }, [idEmpresa, session, estado]);

  useEffect(() => {
    const fetchComprobante = async () => {
      const response = await petitions.getComprobantes(
        idEmpresa(),
        session().token
      );
      if (response.status === "success") {
        var array = response.data.map((e) => ({
          value: e.id,
          label: e.descripcion,
        }));
        setComprobantes(array);
        form1.setValue("tipComprobante", "01", {
          shouldValidate: false,
        })
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };
    fetchComprobante();
  }, [form1, idEmpresa, session]);

  const closeModal =() =>{
    const modalInstance = window.bootstrap.Modal.getInstance(modalRef.current);
    modalInstance.hide();
  }

  const sendSerie = form1.handleSubmit(async (data) => {

    const response = await petitions.insertSerie(idEmpresa(), session().token, data);
    if (response.status === "success") {
      if (response.data) {
        closeModal();
        setEstado(!estado);
        toast.success("Serie registrada correctamente");
        form1.reset(); 
      }
      else{
        closeModal();
        toast.error("Ocurrió un problema, inténtelo mas tarde");  
      }
    } else {
      closeModal();
      var msg =
        typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  });

  const handleUpdate = (row) => {
    form2.setValue('idSerie', row.idSerie,{ shouldValidate: true })
    form2.setValue('tipComprobante', row.tipComprobante,{ shouldValidate: true })
    form2.setValue('serie', row.serie,{ shouldValidate: true })
    form2.setValue('descripcion', row.descripcion,{ shouldValidate: true })
    form2.setValue('estado', row.estado,{ shouldValidate: false })
    form2.setValue('defecto', row.defecto,{ shouldValidate: false })
    const modal = new window.bootstrap.Modal(modalRef2.current);
    modal.show();
  };

  const updateEstado = async (row) => {
    row.estado = (row.estado === "S") ? "N" : "S"
    const response = await petitions.updateSerie(idEmpresa(), session().token, row)
    if (response.status === "success") {
      if (response.data) {
        setEstado(!estado);
        toast.success("Estado actualizado correctamente"); 
      }
      else{        
        toast.warning("Ocurrió un problema, inténtelo mas tarde");  
      }
    } else {
      var msg = typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  }

  const updateDefecto = async (row) => {
    row.defecto = (row.defecto === "S") ? "N" : "S"
    const response = await petitions.updateSerie(idEmpresa(), session().token, row)
    if (response.status === "success") {
      if (response.data) {
        setEstado(!estado);
        toast.success("Defecto actualizado correctamente"); 
      }
      else{        
        toast.warning("Ocurrió un problema, inténtelo mas tarde");  
      }
    } else {
      var msg = typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  }

  const updateSerie = form2.handleSubmit(async (data) => {
    const response = await petitions.updateSerie(idEmpresa(), session().token, data)
    if (response.status === "success") {
      if (response.data) {
        const modalInstance = window.bootstrap.Modal.getInstance(modalRef2.current);
        modalInstance.hide();
        setEstado(!estado);
        toast.success("Serie actualizada correctamente"); 
      }
      else{
        const modalInstance = window.bootstrap.Modal.getInstance(modalRef2.current);
        modalInstance.hide();
        toast.warning("Ocurrió un problema, inténtelo mas tarde");  
      }
    } else {
      const modalInstance = window.bootstrap.Modal.getInstance(modalRef2.current);
      modalInstance.hide();
      var msg = typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  })

  const deleteSerie = (row) => {
    delete row.descripcionComprobante
    toast("¿Estas seguro(a) de eliminar esta serie?", {
      action: {
        label: "Confirmar",
        onClick: async () => {
          const response = await petitions.deleteSerie(
            idEmpresa(),
            session().token,
            row
          );
          if (response.status === "success") {
            setEstado(!estado);
            toast.success("Serie eliminada correctamente"); 
          } else {
            var msg =
              typeof response.code === "string"
                ? response.message
                : response.data;
            toast.error(msg);
          }
        },
      },
    });
  }

  return (
    <>
      <div className="mb-9">
        <div className="row g-2 mb-4">
          <div className="col-auto">
            <h2 className="mb-0">Series</h2>
          </div>
        </div>
        <div className="mb-4">
          <div className="row g-10">
            <div className="col-auto">
              <div className="search-box">
                <input
                  className="form-control search-input search rounded-4 border-0 shadow-sm"
                  type="search"
                  placeholder="Buscar serie"
                  aria-label="Search"
                  value={filtering}
                  onChange={(e) => setFiltering(e.target.value)}
                />
                <span className="fas fa-search search-box-icon"></span>
              </div>
            </div>
            <div className="col-auto">
              <button
                className="btn btn-link text-body me-4 px-0"
                onClick={() => exportToExcel_v1(series, columns, "series")}
              >
                <span className="fa-solid fa-file-export fs-9 me-2"></span>
                Exportar
              </button>
              <button
                className="btn btn-primary rounded-4"
                data-bs-toggle="modal"
                data-bs-target="#modalAgregar"
              >
                <span className="fas fa-plus me-2"></span>Nueva serie
              </button>
            </div>
          </div>
        </div>
        <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-body-emphasis border-top border-bottom border-translucent position-relative top-1">
          <div className="table-responsive scrollbar-overlay mx-n1 px-1">
            {load ? (
              <TableLoad />
            ) : (
              <Table
                data={series}
                columns={columns}
                filtering={filtering}
                setFiltering={setFiltering}
              />
            )}
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="modalAgregar"
        tabIndex="-1"
        aria-labelledby="verticallyCenteredModalLabel"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4">
            <div className="modal-header">
              <h5 className="modal-title" id="verticallyCenteredModalLabel">
                Datos de serie
              </h5>
              <button
                className="btn p-1"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="fas fa-times fs-9"></span>
              </button>
            </div>
            <form onSubmit={sendSerie}>
              <div className="modal-body">
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Tipo de documento
                  </label>
                  <select
                    className="form-select rounded-4"
                    value={form1.watch("tipComprobante")}
                    {...form1.register("tipComprobante", {
                      required: {
                        value: true,
                        message: "Este campo es obligatorio",
                      },
                    })}
                    onChange={(event) => {
                      form1.setValue("tipComprobante", event.target.value, {
                        shouldValidate: true,
                      });
                    }}
                  >
                    {comprobantes.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  {form1.formState.errors?.tipComprobante && (
                    <code>{form1.formState.errors.tipComprobante.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Serie
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form1.register("serie", {
                      required: {
                        value: true,
                        message: "Este campo es obligatorio",
                      },
                      minLength: {
                        value: 4,
                        message: "La serie código debe ser de 4 digitos",
                      },
                      maxLength: {
                        value: 4,
                        message: "Las serie debe ser de 4 digitos",
                      },
                    })}
                  />
                  {form1.formState.errors?.serie && (
                    <code>{form1.formState.errors.serie.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Descripción
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form1.register("descripcion", {})}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Guardar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="modalEditar"
        tabIndex="-1"
        aria-labelledby="verticallyCenteredModalLabel"
        aria-hidden="true"
        ref={modalRef2}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4">
            <div className="modal-header">
              <h5 className="modal-title" id="verticallyCenteredModalLabel">
                Editar serie
              </h5>
              <button
                className="btn p-1"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="fas fa-times fs-9"></span>
              </button>
            </div>
            <form onSubmit={updateSerie}>
              <div className="modal-body">
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Tipo de documento
                  </label>
                  <select
                    className="form-select rounded-4"
                    value={form2.watch("tipComprobante")}
                    {...form2.register("tipComprobante", {
                      required: {
                        value: true,
                        message: "Este campo es obligatorio",
                      },
                    })}
                    onChange={(event) => {
                      form2.setValue("tipComprobante", event.target.value, {
                        shouldValidate: true,
                      });
                    }}
                  >
                    {comprobantes.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  {form2.formState.errors?.tipComprobante && (
                    <code>{form2.formState.errors.tipComprobante.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Serie
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form2.register("serie", {
                      required: {
                        value: true,
                        message: "Este campo es obligatorio",
                      },
                      minLength: {
                        value: 4,
                        message: "La serie código debe ser de 4 digitos",
                      },
                      maxLength: {
                        value: 4,
                        message: "Las serie debe ser de 4 digitos",
                      },
                    })}
                  />
                  {form2.formState.errors?.serie && (
                    <code>{form2.formState.errors.serie.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Descripción
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form2.register("descripcion", {})}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Actualizar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

